export const hierarchyReducer = (state, action) => {
  switch (action.type) {
    case "loadHierarchy":
      console.log("loading Hierarchy");
      return loadHierarchy(state, action.hierarchys);
    case "addHierarchy":
      console.log("adding Hierarchy");
      return addHierarchy(state, action.hierarchy);
    case "editHierarchy":
      console.log("editing Hierarchy");
      return editHierarchy(state, action.hierarchy);
    default:
      return state;
  }
};

const loadHierarchy = (state, hierarchys) => {
  let newState = [...hierarchys];

  return newState;
};
const addHierarchy = (state, hierarchy) => {
  let newState = [...state];
  for (let node of hierarchy.tree) {
    newState.push({
      id: parseInt(newState[newState.length - 1].id) + 1,
      type: hierarchy.name,
      ...node,
    });
  }

  return newState;
};

const editHierarchy = (state, hierarchy) => {
  let newState = state.filter((node) => {
    return node.type !== hierarchy.oldname;
  });
  for (let node of hierarchy.tree) {
    newState.push({
      id: parseInt(newState[newState.length - 1]?.id || 0) + 1,
      type: hierarchy.name,
      ...node,
    });
    return newState;
  }

  return newState;
};
